<template>
  <div class="content">
    <van-search background="#ffffff" shape="round" placeholder="请输入地点名称" ></van-search>
   <div class="node-title">目前可选择上车点</div>
    <div class="main-content">

     <van-tree-select
      height="133vw"
      :items="treeItems"
      :active-id="activeId"
      :main-active-index="mainActiveIndex"
      @click-nav="stationNavClick"
      @click-item="stationNavItemClick"
    >

  </van-tree-select>

     <van-divider class="compmsg">技术提供方：广州润辰</van-divider>
    </div>
  </div>
</template>

<script>
import { TreeSelect, Divider ,Row, Col,Search } from "vant";

export default {
  components: {
    [Search.name]: Search,
    [Row.name]: Row,
    [Col.name]: Col,
    [TreeSelect.name]: TreeSelect,
    [Divider.name]: Divider
  },
  data() {
    return {
          stations:[],
          treeItems:[],
          mainActiveIndex: 0,
          activeId: 0,
    };
  },
  methods: {
   
     //获取获取车站列表
    getStationInfos() { 
        
      let params =this.$utils.getMainUrlParam(2);
      this.$http
        .post(this.$api.API_StationQuery, this.$qs.stringify(params))
        .then(res => {
          console.log(res);
          if (res.success) {
            
             this.stations=res.data;
              console.log(this.stations);
              let list=[];      
              let redirects= this.$utils.searchByRegExp(this.company,this.stations, "company");
              let redirectStations=redirects[0].stations;

              if(redirectStations.length>0){         
              for(let i=0;i<redirectStations.length;i++ ){
                let station=redirectStations[i];
                let newitemText=station.stationCity;
                let newItem={id:station.stationId,text:station.stationName,disabled:!station.canSaleTicket,self:redirectStations[i]};

                let items = this.$utils.searchByRegExp(newitemText, list, "text");
                if(items.length>0){
                  let itemList=items[0].children;    
                  itemList.push(newItem);
                } else{
                  let newItemOjb={text:newitemText,children:[newItem]};
                  list.push(newItemOjb)
                }
              }           
            }
            this.treeItems=list;
          }
        })
        .catch(err => {
          console.log(err);
          // this.$dialog.alert({
          //   title: "提示",
          //   message: err
          // });
        });
        
        
       
    },
    stationNavClick(index){
      this.mainActiveIndex=index;
    },
    stationNavItemClick(data){

      this.activeId = data.id;  
      let node = {
        gid: data.id,
        name: data.text
      };

      node.type = 1;
      this.$store.dispatch("setNode", node);
      console.log(this.$store.state)
    
      this.$router.go(-1);
    } 

  },
  created() {
    this.getStationInfos();
  },
  mounted() {},
  computed:{ },
  watch: {
   
  }
};
</script>
<style lang="less" scoped>
/deep/.van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color:#f58c0c;
}

/deep/.van-sidebar-item--select::before {
    background-color: #ff976a
}

.van-tree-select {
  position: absolute;
  top: 100px;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.van-tree-select__nav {
  background-color: #f3f3f3;
  text-align: center;
}

.van-tree-select__nav .van-tree-select__nitem {
  line-height: 1;
  padding: 15px 9px 15px 15px;
  overflow: inherit;
  white-space: inherit;
}

.van-tree-select__content {
  background-color: #fafafa;
  padding-left: 5px;
  padding-right: 5px;
}

.van-tree-select__item {
  background-color: #fff;
  margin-bottom: 8px;
  /* text-indent: .2rem; */
  border-radius: 3px;
  line-height: 1;
  overflow: inherit;
  white-space: inherit;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 10px;
  padding-right: 10px;
}
.van-tree-select__selected {
  right: 5px;
}

.van-tree-select__nitem--active {
  background-color: #fafafa;
}

.van-tree-select__item--active {
  color: #f5840c;
}

.van-tree-select__nitem--active::after {
  background-color: #f5840c;
}


.node-title {
  line-height: 44px;
  background-color: #fff;
  color: #333;
  border-top: 1px solid #ebedf0;
  text-indent: 15px;
}
 .main-content{
  background: #fafafa
 }
 .main-content .tips{
   font-size:14px;
   color:#ccc;
   padding: '0 16px'; 
   margin:0px
 }
 .main-content .compmsg{
   font-size:12px;
   color:#ccc;
   border-color: '#0094ff';
   padding: '0 16px'; 
   margin:5px 0px
 }

</style>
